function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.3px;}\n            .cls-2,.cls-3,.cls-5{fill:#fff;}.cls-3{font-size:43.32px;font-weight:200;}\n            .cls-4{fill:#3d86ff;}\n            .cls-5{font-size:24px;font-weight:300;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 27.65,
  cy: 27.65,
  r: 27
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M27.65,12.25a12.91,12.91,0,0,0-12.9,12.91.93.93,0,1,0,1.86,0,11,11,0,0,1,22.07,0v6a.94.94,0,1,0,1.87,0v-6A12.91,12.91,0,0,0,27.65,12.25Zm3.93,12.91a3.93,3.93,0,0,0-7.86,0,8,8,0,0,1-8,8,.94.94,0,0,0,0,1.87h0a9.9,9.9,0,0,0,9.91-9.91,2.06,2.06,0,0,1,4.12,0A14,14,0,0,1,16,39.18a.94.94,0,0,0,0,1.87h0A15.91,15.91,0,0,0,31.58,25.16Zm-15.9,12.9a12.9,12.9,0,0,0,12.9-12.9.93.93,0,1,0-1.86,0,11,11,0,0,1-11,11,.94.94,0,0,0,0,1.87Zm21.88-12.9a9.91,9.91,0,1,0-19.82,0,2,2,0,0,1-.6,1.46,2.07,2.07,0,0,1-1.46.6.94.94,0,0,0,0,1.87,3.93,3.93,0,0,0,3.93-3.93,8,8,0,0,1,16.08,0h0v6a3.93,3.93,0,0,0,3.92,3.93h0a.94.94,0,0,0,0-1.87h0a2,2,0,0,1-1.46-.61,2,2,0,0,1-.6-1.45v-6Zm3,12a.93.93,0,0,1-.93.93,6.91,6.91,0,0,1-6.92-6.92v-6a5.05,5.05,0,0,0-10.1,0,6.91,6.91,0,0,1-6.92,6.92.94.94,0,0,1,0-1.87,5.08,5.08,0,0,0,3.57-1.48,5,5,0,0,0,1.48-3.57,6.92,6.92,0,0,1,13.84,0v6a5,5,0,0,0,5,5A.93.93,0,0,1,40.55,37.13ZM33,25.79a.38.38,0,0,1-.09-.12h0Zm6.33,13.39h0a8,8,0,0,1-5.35-2.35h0A8.13,8.13,0,0,1,32,33.76a.93.93,0,0,0-1.77.6,9.9,9.9,0,0,0,2.36,3.78h0A9.87,9.87,0,0,0,39.21,41h0a.94.94,0,0,0,.94-.9A.93.93,0,0,0,39.28,39.18Z"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls-3",
  transform: "translate(80.94 42.92)"
}, "DigiU"), /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  x: 210.01,
  y: 6.15,
  width: 70.89,
  height: 38.4,
  rx: 8.86
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M200.21,26.16l17.67,10.2a.93.93,0,0,0,1.4-.81V15.15a.93.93,0,0,0-1.4-.81l-17.67,10.2A.94.94,0,0,0,200.21,26.16Z"
}), /*#__PURE__*/React.createElement("text", {
  className: "cls-5",
  transform: "translate(219.29 35.67)"
}, "Beta")));

var SvgBrainvivo3 = function SvgBrainvivo3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280.9 55.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrainvivo3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brainvivo3.d6f4be5a.svg";
export { ForwardRef as ReactComponent };